import { render } from "./U_monitoringData.vue?vue&type=template&id=1a66b070&scoped=true"
import script from "./U_monitoringData.vue?vue&type=script&lang=js"
export * from "./U_monitoringData.vue?vue&type=script&lang=js"

import "./U_monitoringData.vue?vue&type=style&index=0&id=1a66b070&lang=scss&scoped=scoped"

import exportComponent from "/Users/cw/Desktop/BME/screen_project_315/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1a66b070"]])

export default __exports__